// TEACH-UX P1-a — "open the staff-messages panel" bus, mirroring features/calendar/calendarBus
// VERBATIM (which itself mirrors miraIntentBus). Chat's floating launcher button is retired: the
// three stacked FABs became one, so any surface — the teacher avatar menu today, a nav affordance
// tomorrow — asks the panel to open without knowing where it lives.
//
// A launcher that isn't mounted, or whose auth gate refused it, simply doesn't hear this. That is
// the property that lets the button go away without the gate going with it: the bus carries a
// REQUEST, and ChatLauncher's own `if (!myId) return null` still decides whether anything opens.
const listeners = new Set();

export function onChatOpen(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * @param options optional. `{ withUserId }` asks the panel to open the 1:1 thread with that USER
 *        (not teacher) id instead of the conversation list.
 *
 * W26 / C-257 — the Messages tab and the "Send a message" page action both mean "message HER", and
 * a request that could only say "open the panel" would land the admin on a list of the whole
 * organisation to find her in. The option is carried rather than acted on here: the launcher still
 * decides, and its `if (!myId) return null` gate is untouched.
 *
 * EXISTING CALLERS ARE UNCHANGED. The avatar menu calls this with no argument and every listener
 * that ignores its parameter keeps working, which is why this is an added option and not a second
 * bus.
 */
export function requestChatOpen(options) {
  listeners.forEach((listener) => {
    try {
      listener(options || {});
    } catch {
      /* swallow — a launcher not mounted yet simply doesn't hear it */
    }
  });
}
